import React from "react";
import { observer } from "mobx-react";
import "../scss/index.scss";
import * as NativeBridge from "../utils/NativeBridge";

const Main = observer(() => {
  const vibrate = () => {
    NativeBridge.vibrate();
  };

  return (
    <div className="container">
      <div className="title">webapp sample</div>
      <div className="body">
        <button onClick={vibrate}>vibrate</button>
        <button>kkk</button>
        <button>google</button>
        <button>youtube</button>
      </div>
      <div className="foot">foot</div>
    </div>
  );
});

export default Main;
